// extracted by mini-css-extract-plugin
module.exports = {"container":"RelatedIncidentItem_container__226I0","link":"RelatedIncidentItem_link__K3S1s","gray":"RelatedIncidentItem_gray__2xfa9"};